const Popup = () => {
    const domElements = {
        triggers: document.querySelectorAll(".js-popup-trigger"),
    };
    if (!domElements.triggers.length)
        return;
    domElements.triggers.forEach((trigger) => {
        const newId = trigger.getAttribute("data-popup-id");
        if (!newId) {
            console.warn('A valid "data-popup-id" attribute is required for the trigger element');
            return;
        }
        const popup = document.getElementById(newId);
        if (popup) {
            trigger.addEventListener("click", () => {
                handlePopupEvents(popup);
            });
        }
    });
};
const handlePopupEvents = (popup) => {
    const popupDomElements = {
        popup,
        close: popup.querySelector(".js-popup-close"),
        innerElement: popup.querySelector(".js-popup-inner"),
        video: popup.querySelector("video"),
    };
    if (!popupDomElements.close || !popupDomElements.innerElement)
        return;
    popup.classList.add("is-active");
    if (popupDomElements.video) {
        const videoSrc = popupDomElements.video.getAttribute("data-src");
        if (videoSrc && !popupDomElements.video.src) {
            popupDomElements.video.src = videoSrc;
        }
        popupDomElements.video.play();
    }
    popupDomElements.close.addEventListener("click", () => closePopup(popupDomElements));
    popup.addEventListener("click", () => closePopup(popupDomElements));
    popupDomElements.innerElement.addEventListener("click", (e) => e.stopPropagation());
};
const closePopup = (popupDomElements) => {
    popupDomElements.popup?.classList.remove("is-active");
    popupDomElements.innerElement?.removeEventListener("click", (e) => e.stopPropagation());
    popupDomElements.close?.removeEventListener("click", () => closePopup(popupDomElements));
    popupDomElements.popup?.removeEventListener("click", () => closePopup(popupDomElements));
    if (popupDomElements.video) {
        popupDomElements.video.pause();
    }
};
export default Popup;
